import React, { Component } from 'react';
import {FaIcon} from "../FaIcon";
import {ALLOCATED_AMOUNT_GOAL, PERCENTAGE_GOAL} from "./BudgetPartialGoalsConfiguration";
import {BusinessUnitPeriodField, BusinessUnitPeriodFieldClass} from "../client/BusinessUnitPeriodField";
import moment from "moment";
import {DayPicker} from "react-day-picker";
import BudgetValueInput from "./BudgetValueInput";
import {CurrencyHelper} from "../../utils/CurrencyHelper";
import { withTranslation } from 'react-i18next';

class BudgetPartialGoalRowsClass extends Component {
    MAX_BUDGET_PARTIAL_GOALS = 9;

    constructor(props) {
        super(props);
        this.state = {
            rows: props.budgetPartialGoals !== undefined && props.budgetPartialGoals.length
                ? props.budgetPartialGoals.slice().sort((a, b) => new Date(a.date) - new Date(b.date))
                : [{ date: '', value: '', type: PERCENTAGE_GOAL }],
            openDatePickerIndex: null,
        };
    }

    handleInputChange = (index, field, value) => {
        const rows = [...this.state.rows];
        rows[index][field] = value;
        this.setState({ rows }, () => this.props.onChange(rows));
    };

    addRow = () => {
        this.setState(
            (prevState) => ({
                rows: [...prevState.rows, { date: '', value: '', type: PERCENTAGE_GOAL }],
            }),
            () => this.props.onChange(this.state.rows)
        );
    };

    removeRow = (index) => {
        const rows = [...this.state.rows];
        rows.splice(index, 1);
        this.setState({ rows }, () => this.props.onChange(rows));
    };

    handleDateChange = (index, date) => {
        const rows = [...this.state.rows];
        rows[index].date = date;
        this.setState({ rows, openDatePickerIndex: null }, () => this.props.onChange(rows));
    };

    toggleDatePicker = (index) => {
        this.setState(prevState => ({
            openDatePickerIndex: prevState.openDatePickerIndex === index ? null : index
        }));
    };

    render() {
        const { rows, openDatePickerIndex } = this.state;
        const { budgetPeriodType, budgetFromDate, budgetToDate } = this.props;
        // Parse the budgetFromDate into a Date object if it's not already
        const lastDayEligible = new Date(budgetToDate);
        lastDayEligible.setDate(lastDayEligible.getDate() - 1);
        const totalRows = rows.length;

        const renderedRows = rows.map((row, index) => this.renderRow(index, budgetPeriodType, row.date, row.type, row.value, openDatePickerIndex === index, budgetFromDate, budgetToDate, lastDayEligible, totalRows, false));
        renderedRows.push(this.renderRow(rows.length, budgetPeriodType, budgetToDate, ALLOCATED_AMOUNT_GOAL, this.props.budgetTotalAmount, false, budgetFromDate, budgetToDate, budgetToDate, totalRows, true));

        return (<div className="budget_partial_goal_rows">{renderedRows}</div>);
    }

    renderRow(index, budgetPeriodType, aDate, aType, value, isDatePickerOpen, budgetFromDate, budgetToDate, lastDayEligible, totalRows, readOnly) {
        const { t } = this.props;
        return (
            <div key={index} className="row g-2 align-items-center mb-2">
                <div className="col-md-auto">
                    <span>{`${index + 1}.`}</span>
                </div>
                <div className="col-md-auto">
                    <span>{t('budget_partial_goal.by_day')}</span>
                </div>

                <div className={`col-md-auto ${readOnly ? "read-only" : ""}`}>
                    {budgetPeriodType === BusinessUnitPeriodFieldClass.temporalPeriodType ? this.renderDateInputForEventualPeriod(aDate, readOnly, index, isDatePickerOpen, budgetFromDate, budgetToDate) : this.renderDayOfMonthlyPeriodSelect(aDate, readOnly, budgetFromDate, lastDayEligible, index)}
                </div>

                <div className="col-md-auto">
                    <span>{t('budget_partial_goal.want_to_have_invested')}</span>
                </div>

                <div className={`col-md-auto ${readOnly ? "read-only" : ""}`}>
                    {this.renderValueInput(value, readOnly, index, aType)}
                </div>

                <div className="col-md-auto">
                    {this.renderTypeOfValueSelect(aType, readOnly, index)}
                </div>

                <div className="col-md-auto">
                    {(index === (totalRows-1)) && totalRows < this.MAX_BUDGET_PARTIAL_GOALS ? (
                        !readOnly && (
                            <button onClick={this.addRow} className={"enabled"}>
                                <FaIcon iconName="plus-square"/>
                            </button>
                        )
                    ) : null}

                    {index === totalRows - 1 && index > 0 ? (
                        !readOnly && (
                            <button onClick={() => this.removeRow(index)} className="enabled">
                                <FaIcon iconName="minus-square"/>
                            </button>
                        )
                    ) : null}
                </div>
            </div>
        );
    }

    renderDayOfMonthlyPeriodSelect(aDate, readOnly, budgetFromDate, lastDayEligible, index) {
        const { t } = this.props;
        if(readOnly)
            return <span>{t('budget_partial_goal.day_of_month', {day: aDate.getDate()})}</span>

        const options = this._generateSelectOptions(budgetFromDate, lastDayEligible);

        return <select
            className="form-control form-select"
            value={aDate ? `${aDate.getFullYear()}${String(aDate.getMonth() + 1).padStart(2, '0')}${String(aDate.getDate()).padStart(2, '0')}` : ''}
            onChange={readOnly ? null : (e) => {
                const selectedDateString = e.target.value;
                const selectedDate = new Date(
                    selectedDateString.substring(0, 4), // Year
                    parseInt(selectedDateString.substring(4, 6), 10) - 1, // Month (0-based)
                    selectedDateString.substring(6, 8) // Day
                );

                if (selectedDate >= new Date(budgetFromDate) && selectedDate <= new Date(lastDayEligible)) {
                    this.handleInputChange(index, 'date', selectedDate);
                } else {
                    alert(t('budget_partial_goal.selected_date_out_of_range'));
                }
            }}
            disabled={readOnly}
        >
            <option value=""></option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>;
    }

    _generateSelectOptions(budgetFromDate, lastDayEligible){
        const options = [];
        let currentDate = new Date(budgetFromDate);

        // Generate options from budgetFromDate to lastDayEligible
        while (currentDate <= lastDayEligible) {
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const yyyymmdd = `${year}${month}${day}`;

            options.push({
                value: yyyymmdd,
                label: currentDate.getDate()
            });

            currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
        }

        return options;
    }

    renderTypeOfValueSelect(aType, readOnly, index) {
        if(readOnly)
            return;

        return (
            <select
                className="form-control form-select"
                value={aType}
                onChange={readOnly ? null : (e) => this.handleInputChange(index, 'type', e.target.value)}
                disabled={readOnly}
            >
                <option value={PERCENTAGE_GOAL}>%</option>
                <option value={ALLOCATED_AMOUNT_GOAL}>$</option>
            </select>
        );
    }

    renderValueInput(value, readOnly, index, aType) {
        if(readOnly) {
            if(value === null || value === undefined || value === '')
                return <span>-</span>;

            if(aType === PERCENTAGE_GOAL)
                return <span>{`${value}%`}</span>;
            else {
                value = CurrencyHelper.formatNumberToCurrency(value);
                return <span>{`$ ${value}`}</span>;
            }
        }

        if(aType === PERCENTAGE_GOAL) {
            return <input
                type="number"
                className="form-control value-input"
                value={value}
                onChange={readOnly ? null : (e) => this.handleInputChange(index, 'value', e.target.value)}
                min={aType === PERCENTAGE_GOAL ? 1 : 0}
                max={aType === PERCENTAGE_GOAL ? 99 : undefined}
                disabled={readOnly}
            />;
        } else if(aType === ALLOCATED_AMOUNT_GOAL) {
            return <BudgetValueInput hideCurrency={true}
                                     amountClassName={"value-input"}
                                     readOnly={readOnly}
                                     onAmountChange={(newAmount) => (this.handleInputChange(index, 'value', newAmount))}
                                     budgetAmount={value}
            />;
        } else {
            throw new Error("Error 39824938492")
        }
    }

    formatDateToYYYYMMDD(date) {
        const day = String(date.getDate()).padStart(2, '0');    // Get day and pad with zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-based) and pad with zero
        const year = date.getFullYear();                        // Get full year

        return `${year}-${month}-${day}`;
    }

    renderDateInputForEventualPeriod(aDate, readOnly, index, isDatePickerOpen, budgetFromDate, lastDayEligible) {
        const { t } = this.props;
        if (readOnly) {
            return <span>{aDate ? this.formatDateToYYYYMMDD(aDate) : ''}</span>;
        }

        return (
            <div className="date-picker-container">
                <input
                    type="text"
                    readOnly
                    className="form-control date-input"
                    value={aDate ? this.formatDateToYYYYMMDD(aDate) : t('budget_partial_goal.select')}
                    onClick={() => this.toggleDatePicker(index)}
                />
                {isDatePickerOpen && (
                    <div className="date-picker-popover">
                        <DayPicker
                            mode="single"
                            selected={aDate ? moment(aDate).toDate() : null}
                            onSelect={(date) => this.handleDateChange(index, date)}
                            disabled={(date) => date < moment(budgetFromDate).toDate() || date > moment(lastDayEligible).toDate()}
                            numberOfMonths={1}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export const BudgetPartialGoalRows = withTranslation()(BudgetPartialGoalRowsClass);
export default BudgetPartialGoalRows;
